import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

interface Props {
  readonly label: string;

  onClick?(): void;
}

export const LinkLikeButton: React.FC<Props> = (props: Props): React.ReactElement => {
  const { onClick, label } = props;

  return (
    <Button
      color="inherit"
      type="submit"
      sx={styles.container}
      fullWidth={true}
      disableRipple={true}
      onClick={onClick}>
      <Typography variant="body2">{label}</Typography>
    </Button>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
};
